<template>
  <div id="mjGap" class="pt-spc14">
    <h1
      v-if="title"
      class="small productName ae-2 fromRight font-anonymouse text-2xl font-normal opacity-100 leading-lh4 tracking-normal mb-0 text-black ml-spc15"
    >{{title}}</h1>
    <div v-if="subtitle" class="productTitle ae-3 fromRight done">
      <p
        class="text-lg font-anonymouse font-medium mb-0 ml-spc6 mt-0 text-black uppercase opacity-90"
      >{{subtitle}}</p>
    </div>
    <p
      v-if="desc || descBoldText"
      class="add-new-txt ae-2 fromRight text-size7 font-anonymouse leading-lh3 mt-spc17 mb-spc5 text-dark_p"
    >
      <b v-if="descBoldText">{{descBoldText}}</b>
      {{desc}}
    </p>
    <p
      v-if="desc2BoldText || desc2"
      class="add-new-txt ae-2 fromRight text-size7 font-anonymouse leading-lh3 mt-spc17 mb-spc5 text-dark_p"
    >
      <b v-if="desc2BoldText">{{desc2BoldText}}</b>
      {{desc2}}
    </p>
    <ul class="flex flex-wrap product-content" id="productCopy">
      <li
        v-if="sizes.sticks || sizes.sticks2 || sizes.stickoutland || sizes.sizetitle"
        class="col-8-12 ae-3 xl:w-2/3 w-2/3 fromRight opacity-100 mt-spc19 md:w-full"
      >
        <h3
          class="productDetails font-anonymouse text-sm font-medium text-black uppercase mb-spc5 tracking-normal ml-spc18"
        >{{sizes.sizetitle ? (sizes.sizetitle) : 'Sizes'}}</h3>
        <p
          v-if="sizes.sticks"
          class="smallDetails text-sm font-medium font-anonymouse tracking-normal opacity-100 leading-lh3"
        >{{sizes.sticks}}</p>
        <p
          v-if="sizes.sticks2"
          class="smallDetails long text-sm font-medium font-anonymouse tracking-normal opacity-100 leading-lh3 mt-spc4"
        >{{sizes.sticks2}}</p>
        <p
          v-if="sizes.stickoutland"
          class="smallDetails long text-sm font-medium font-anonymouse tracking-normal opacity-100 leading-lh3 mt-spc4"
        >{{sizes.stickoutland}}</p>
      </li>
      <li
        v-if="colors.clr || colors.clr2 || colors.clr3 || colors.colortitle"
        class="col-8-12 ae-3 xl:w-2/3 w-2/3 fromRight opacity-100 mt-spc19 md:w-full"
      >
        <h3
          class="productDetails font-anonymouse text-sm font-medium text-black uppercase mb-spc5 tracking-normal ml-spc18"
        >{{colors.colortitle ? (colors.colortitle) : 'COLORS'}}</h3>
        <p
          v-if="colors.clr"
          class="smallDetails text-sm font-medium font-anonymouse tracking-normal opacity-100 leading-lh3"
        >{{colors.clr}}</p>
        <p
          v-if="colors.clr2"
          class="smallDetails text-sm font-medium font-anonymouse tracking-normal opacity-100 leading-lh3 mt-spc4"
        >{{colors.clr2}}</p>
        <p
          v-if="colors.clr3"
          class="smallDetails text-sm font-medium font-anonymouse tracking-normal opacity-100 leading-lh3 mt-spc4"
        >{{colors.clr3}}</p>
      </li>
      <li
        v-if="fabrics.fabric || fabrics.fabric2 || fabrics.fabric3"
        class="col-8-12 ae-3 xl:w-2/3 w-2/3 fromRight opacity-100 mt-spc19 md:w-full"
      >
        <h3
          class="productDetails font-anonymouse text-sm font-medium text-black uppercase mb-spc5 tracking-normal ml-spc18"
        >{{fabrics.fabrictitle ? (fabrics.fabrictitle) : 'FABRIC'}}</h3>
        <p
          v-if="fabrics.fabric"
          class="smallDetails text-sm font-medium font-anonymouse tracking-normal opacity-100 leading-lh3"
        >{{fabrics.fabric}}</p>
        <p
          v-if="fabrics.fabric2"
          class="smallDetails text-sm font-medium font-anonymouse tracking-normal opacity-100 leading-lh3 mt-spc4"
        >{{fabrics.fabric2}}</p>
        <p
          v-if="fabrics.fabric3"
          class="smallDetails text-sm font-medium font-anonymouse tracking-normal opacity-100 leading-lh3 mt-spc4"
        >{{fabrics.fabric3}}</p>
      </li>
      <li
        v-if="prices.price1 || prices.price2 || prices.price3 || prices.pricestitle"
        class="col-4-12 ae-4 xl:w-1/3 w-1/3 fromRight opacity-100 mt-spc19 md:w-full"
      >
        <h3
          class="productDetails font-anonymouse text-sm font-medium text-black uppercase mb-spc5 tracking-normal ml-spc18"
        >{{prices.pricestitle ? (prices.pricestitle) : 'Unit Prices'}}</h3>
        <p
          v-if="prices.price1"
          class="smallDetails text-sm font-medium font-anonymouse tracking-normal opacity-100 leading-lh3"
        >{{prices.price1}}</p>
        <p
          v-if="prices.price2"
          class="smallDetails long text-sm font-medium font-anonymouse tracking-normal opacity-100 leading-lh3 mt-spc4"
        >{{prices.price2}}</p>
        <p
          v-if="prices.price3"
          class="smallDetails long text-sm font-medium font-anonymouse tracking-normal opacity-100 leading-lh3 mt-spc4"
        >{{prices.price3}}</p>
      </li>

      <SectionDetailsButtons
        :btn1title="btn1title"
        :btn1url="btn1url"
        :btn2title="btn2title"
        :btn2url="btn2url"
        btnwrapClass="w-full opacity-100 mt-spc19"
      />
    </ul>
  </div>
</template>

<script>
import SectionDetailsButtons from "./SectionDetailsButtons";

export default {
  props: {
    btn1title: {},
    btn2title: {},
    btn1url: {},
    btn2url: {},
    sizes: {
      type: Object
    },
    prices: {
      type: Object
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    descBoldText: {
      type: String
    },
    desc: {
      type: String
    },
    desc2BoldText: {
      type: String
    },
    desc2: {
      type: String
    },
    colors: {},
    fabrics: {}
  },
  name: "SectionDetailsContent",
  components: {
    SectionDetailsButtons
  }
};
</script>

<style scoped>
</style>